import { ErrorBoundary } from '@components/error';
import { UserType } from '@constants/app';
import { tryUntilTrue } from '@utils/data';
import React from 'react';
import { AdminAuthContextValue, AdminAuthContext } from './AdminAuthContext';

type Props = React.PropsWithChildren<AdminAuthContextValue>;

// type Props = AdminAuthContextValue;

export const AdminAuthProvider: React.FC<Props> = ({ authInfo, children }) => {
  const providerValue = React.useMemo(() => ({ authInfo }), [authInfo]);

  React.useEffect(() => {
    tryUntilTrue(() => {
      if (
        authInfo?.userInfo &&
        authInfo.tenantInfo &&
        ErrorBoundary.bugsnagClient
      ) {
        ErrorBoundary.bugsnagClient.addMetadata('user', {
          userType: UserType.ADMIN,
          tenant: authInfo.tenantInfo.tenant,
        });
        ErrorBoundary.bugsnagClient.setUser(
          authInfo.userInfo.sub,
          authInfo.userInfo.email,
        );
      }
      return !!ErrorBoundary.bugsnagClient;
    });
  }, [authInfo]);

  return (
    <AdminAuthContext.Provider value={providerValue}>
      {children}
    </AdminAuthContext.Provider>
  );
};
